import { createRoute, lazyRouteComponent } from '@tanstack/react-router'

import { sessionOrNone } from '../auth/me.ts'
import { NAV_PATHS } from '../navigation/paths.ts'
import { entryRoute } from './entry.tsx'

// The public end of an invitation link, a sheet of the entrance. No guard, but the session is read: why,
// and the three outcomes, in apps/frontend/docs/accesso.md

export interface ActivationSearch {
  readonly token: string
}

/** An absent or empty token is the fifth outcome of the page, not a throw: the person who
 *  clicked a mangled link needs the screen that says so, not the router's error boundary. */
export function parseToken(value: unknown): string {
  return typeof value === 'string' ? value : ''
}

export const activationRoute = createRoute({
  getParentRoute: () => entryRoute,
  path: NAV_PATHS.activation,
  validateSearch: (search: Record<string, unknown>): ActivationSearch => ({
    token: parseToken(search.token),
  }),
  beforeLoad: async ({ context }) => ({ session: await sessionOrNone(context.queryClient) }),
  component: lazyRouteComponent(() => import('../pages/activation.tsx')),
})
